import axios from 'axios';
import { baseUrl } from './config';

// eslint-disable-next-line import/prefer-default-export
export const registerRequest = (data) => axios.post(`${baseUrl}/support`, data);
